import { ChangeDetectorRef, Component, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, PercentPipe } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { JapanDatePipe } from '../../pipe/japan-date.pipe';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { BadgeModule } from 'primeng/badge';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { RoutingService } from 'src/app/services/routing.service';
import { SubtitleService } from 'src/app/services/subtitle.service';
import { DateService } from 'src/app/services/date.service';
import { Router } from '@angular/router';
import { UserPricetarService } from 'src/app/services/user-pricetar.service';
import { UserSedoristService } from 'src/app/services/user-sedorist.service';
import {
  FilterOtherSetting,
  FilterUserProduct,
  UpdateUserPricetarProductMutationVariables,
  UpdateUserSedoristProductMutationVariables,
  UserPricetarProductsQueryVariables,
  UserSedoristProductsQueryVariables,
  YamadaProductsGQL,
  EdionProductsGQL,
  DonkiProductsGQL,
} from 'src/gql/generated';
import { firstValueFrom } from 'rxjs';
import { MessageService } from '../../services/message.service';
import { BuyingStoreService } from '../../services/buying-store.service';
import moment from 'moment';
import { UserService } from 'src/app/services/user.service';
import { AmazonCategoryService } from 'src/app/services/amazon-category.service';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TooltipModule } from 'primeng/tooltip';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { KeepaGraphComponent } from '../parts/keepa-graph/keepa-graph.component';
import { ProductImageGalleryComponent } from './product-image-gallery/product-image-gallery.component';
import { ProductImageFieldsFragment } from 'src/gql/generated';
import { ImageOwnerType } from 'src/app/services/image.service';

@Component({
  selector: 'app-product-share',
  templateUrl: './product-share.component.html',
  styleUrls: ['./product-share.component.sass'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DatePickerModule,
    SelectModule,
    PopoverModule,
    ButtonModule,
    MultiSelectModule,
    TableModule,
    CardModule,
    PanelModule,
    SelectButtonModule,
    CheckboxModule,
    InputTextModule,
    BadgeModule,
    DialogModule,
    ConfirmPopupModule,
    PercentPipe,
    JapanDatePipe,
    IconFieldModule,
    InputIconModule,
    TooltipModule,
    ToggleSwitchModule,
    KeepaGraphComponent,
    ProductImageGalleryComponent,
  ],
})
export class ProductShareComponent implements OnInit {
  form: UntypedFormGroup;
  param: ProductShareFilterParam;
  sharedOptions = [
    { name: '全ての商品', value: FilterUserProduct.All },
    { name: '自分の商品', value: FilterUserProduct.My },
    { name: '店舗未設定商品', value: FilterUserProduct.Nonestore },
  ];
  otherSettingOptions = [
    { name: '寝かせのみ', value: FilterOtherSetting.IsSleeped },
    {
      name: 'レジ落ちのみ',
      value: FilterOtherSetting.IsPriceDownInCacheRegister,
    },
    { name: 'メモありのみ', value: FilterOtherSetting.HasMemo },
    { name: '知財・真贋ありのみ', value: FilterOtherSetting.HasIpMemo },
  ];

  pageSizes = [{ size: 30 }, { size: 50 }, { size: 100 }];
  selectedPageSize = { size: 30 };

  sharedOptionVal = this.sharedOptions[0];
  otherSettingVal;
  buyingStoreVal;
  buyingStoreTypeVal;
  users;
  userVal;
  showColsVal = true;
  isHiddenUnPublic = false;
  isHideSheetDataProducts = false;
  pricetars: Array<Pricetar>;
  sedorists: Array<Sedorist>;
  mergedList: Array<Merged>;
  selectedMergeds: Array<Merged> = []; // 一括操作用に選択された行
  bulkMemo = ''; // 一括メモ入力

  types: Array<BuyingStoreType> = [];
  buyingStores: Array<BuyingStore>;
  lastBuyingStore: BuyingStore;
  amazonCategories: Array<AmazonCategory>;
  amazonCategoryVal: string;
  selectedBuyingStore: BuyingStore;
  newBuyingStoreName: string;
  isAdmin: boolean;
  isNonoGroup = false;

  selectedColumnId: number; // sedorist / pricetarの店舗設定時に選択したID
  selectedFromMeged: boolean;
  selectedMerged: Merged; // mergedの店舗設定時に選択したobject

  showPricetarModal = false;
  showSedoristModal = false;

  // modal setting
  settingPublic: boolean;
  settingIsPriceDownInCacheRegister: boolean;
  settingIsPriceNegotiation: boolean;
  settingIsSleeped: boolean;
  settingMemo: string;
  settingIpMemo: string;

  // dialog for yamada/edion/donki products
  showProductDetailDialog = false;
  selectedProductType: 'yamada' | 'edion' | 'donki' | null = null;
  selectedProductId: string | null = null;
  productDetailData: any = null;
  isLoadingProductDetail = false;

  // area filter for product detail dialog
  availableAreas: Array<{ id: string; name: string; value: string }> = [];
  selectedArea: string | null = null;
  filteredStocks: any[] = [];

  // image gallery dialog state
  showImageGalleryDialog = false;
  imageGalleryOwnerType: ImageOwnerType | null = null;
  imageGalleryOwnerId: number | null = null;
  imageGalleryImages: ProductImageFieldsFragment[] = [];
  imageGalleryCanEdit = false;
  imageGalleryProductName = '';
  private imageGallerySource: 'pricetar' | 'sedorist' | 'merged' | null = null;

  constructor(
    private router: Router,
    private builer: UntypedFormBuilder,
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
    private routingService: RoutingService,
    private subtitleService: SubtitleService,
    private userService: UserService,
    private dateService: DateService,
    private messageService: MessageService,
    private pricetarService: UserPricetarService,
    private sedoristService: UserSedoristService,
    private buyingStoreService: BuyingStoreService,
    private amazonCategoryService: AmazonCategoryService,
    private confirmationService: ConfirmationService,
    private yamadaProductsGQL: YamadaProductsGQL,
    private edionProductsGQL: EdionProductsGQL,
    private donkiProductsGQL: DonkiProductsGQL,
  ) {
    this.routingService.loginRequired();
    this.userService.shareRequired();
    this.subtitleService.setSubTitle('商品共有');
  }

  ngOnInit(): void {
    this.initForm();
    this.loadUsers();
    this.loadBuyingStore();
    this.loadMe();
    this.loadAmazonCategory();
  }

  initForm() {
    const fromYear = this.dateService.getAddedDateTrancated(-30).getFullYear();
    this.param = {
      fromDate: moment().startOf('month').toDate(),
      toDate: this.dateService.getAddedDateTrancated(1),
    } as ProductShareFilterParam;
    this.form = this.builer.group({
      keyword: [this.param.keyword, []],
      fromDate: [this.param.fromDate, []],
      toDate: [this.param.toDate, []],
      sharedOption: [this.sharedOptionVal, []],
      otherSetting: [this.otherSettingVal, []],
      buyingStore: [this.buyingStoreVal, []],
      buyingStoreType: [this.buyingStoreTypeVal, []],
      amazonCategory: [this.amazonCategoryVal, []],
      user: [this.userVal, []],
    });
  }

  loadAmazonCategory() {
    this.amazonCategoryService.list(true, (resp) => {
      this.amazonCategories = resp.amazonCategories.map((c) => {
        return {
          id: c.id,
          name: c.name,
        };
      });
    });
  }

  loadMe() {
    this.userService.me((resp) => {
      this.isAdmin = resp.userRole === 'admin';
      this.isNonoGroup = resp.userGroup?.name === 'nono' || resp.userGroup?.name === 'ののコン';
    });
  }

  goBack() {
    this.router.navigate(['/']);
  }

  goRegister() {
    this.router.navigate(['/share/register']);
  }

  goStoreManage() {
    this.router.navigate(['/share/store']);
  }

  clear() {
    this.sedorists = [];
    this.pricetars = [];
    this.mergedList = [];
    this.selectedMergeds = [];
    this.bulkMemo = '';
  }

  changeType() {
    const type = this.form.value.buyingStoreType;
    if (type) {
      this.buyingStores = type.stores;
    } else {
      this.loadBuyingStore();
    }
  }

  async loadUsers() {
    this.users = [];

    await this.userService.getAllUsers((resp) => {
      const allUsers = resp.users
        ?.filter((u) => !!u.name)
        .map((u) => ({
          ...u,
          displayName: u.orderInGroup != null ? `${u.orderInGroup}.${u.name}` : u.name,
        }));
      const firstUsers = allUsers.filter((u) => u.name.includes('管理人'));
      const otherUsers = allUsers.filter((u) => !u.name.includes('管理人'));
      this.users = firstUsers.concat(otherUsers);
    });
  }

  loadBuyingStore() {
    this.types = [];
    this.buyingStores = [];

    this.buyingStoreService.fetchTypes((types) => {
      types.buyingStoreTypes.forEach((t) => {
        const stores = [];
        t.buyingStores.forEach((s) => {
          stores.push({
            id: s.id,
            name: s.name,
          });
          this.buyingStores.push({
            id: s.id,
            name: t.name + ' - ' + s.name,
          });
        });
        this.types.push({
          id: t.id,
          name: t.name,
          stores,
        });
      });
    });
  }

  hiddenCols(e) {
    this.showColsVal = !e.checked;
  }

  hiddenUnPublic(e) {
    this.isHiddenUnPublic = !!e.checked;
  }

  onHideSheetDataProductsChange(e) {
    this.isHideSheetDataProducts = !!e.checked;
  }

  private shouldHideProduct(sheetData?: any): boolean {
    if (!this.isHideSheetDataProducts) {
      return false;
    }
    return this.hasSheetData(sheetData);
  }

  async doSearchPricetar() {
    this.clear();
    this.pricetars = this.collapseBySku(await this.searchPricetar());
  }

  private async searchPricetar(): Promise<Pricetar[]> {
    const v = this.form.value;
    const buyingStoreIds = v.buyingStore ? [v.buyingStore.id] : undefined;
    const buyingStoreTypeId = v.buyingStoreType ? v.buyingStoreType.id : undefined;
    const keyword = v.keyword;
    const filterUserProduct = v.sharedOption.value;
    const fromDate = moment(v.fromDate).format('YYYY-MM-DD');
    const toDate = moment(v.toDate).format('YYYY-MM-DD');
    const filterUserIds = v.user?.map((u) => u.id);
    const amazonCategoryId = v.amazonCategory?.id;
    const filterOtherSetting = v.otherSetting?.value;

    const body: UserPricetarProductsQueryVariables = {
      keyword,
      fromDate,
      toDate,
      filterUserProduct,
      filterOtherSetting,
      buyingStoreIds,
      buyingStoreTypeId,
      filterUserIds,
      amazonCategoryId,
    };
    const result = [];
    await this.pricetarService.list(
      body,
      (data) => {
        data.userPricetarProducts.forEach((p) => {
          if (this.isHiddenUnPublic && !p.isPublic) {
            return;
          }
          if (this.shouldHideProduct(p.sheetData)) {
            return;
          }
          const buyingStore = p.buyingStore && p.buyingStore.name;
          const profit = p.sellingPrice - p.buyingPrice - p.salesCommission;
          const profitRate = profit / p.sellingPrice;
          result.push({
            id: p.id,
            asin: p.amazonProduct.asin,
            jan: p.product?.jan,
            imageUrl: p.amazonProduct.imageUrl,
            sku: p.sku,
            email: p.user.email,
            name: p.user.name,
            productName: p.productName,
            buyingPrice: p.buyingPrice,
            sellingPrice: p.sellingPrice,
            orderDate: new Date(p.orderDate),
            buyingStore,
            salesCommission: p.salesCommission,
            profit,
            profitRate,
            deliveryRoute: p.deliveryRoute,
            memo: p.memo,
            ipMemo: p.ipMemo,
            isPriceDownInCacheRegister: p.isPriceDownInCacheRegister,
            isSleeped: p.isSleeped,
            isPriceNegotiation: p.isPriceNegotiation,
            condition: p.condition,
            topCategory: p.topCategory,
            isPublic: p.isPublic,
            createdAt: new Date(p.createdAt),
            sheetData: p.sheetData,
            images: p.images ?? [],
          });
        });
      },
      (err) => {
        console.log(err);
      },
    );
    return result;
  }

  doDeletePricetar(pricetarId: number, event?: Event) {
    //this.confirmationService.confirm({
    //  target: event?.target as EventTarget,
    //  message: '本当に削除しますか？',
    //  icon: 'pi pi-exclamation-triangle',
    //  acceptButtonStyleClass: 'p-button-danger p-button-sm',
    //  accept: () => {
    this.pricetarService.delete({ id: pricetarId }, (resp) => {
      if (this.selectedFromMeged) {
        this.mergedList = this.mergedList.filter((p) => p.pricetarId !== pricetarId);
      } else {
        this.pricetars = this.pricetars.filter((p) => p.id !== pricetarId);
      }
      this.messageService.setFlashMessageWithClear('success', '削除成功', '削除しました', 3000);
      this.showPricetarModal = false;
    });
    //  },
    //});
  }

  doDeleteSedorist(sedoristId: number, event?: Event) {
    //this.confirmationService.confirm({
    //  target: event?.target as EventTarget,
    //  message: '本当に削除しますか？',
    //  icon: 'pi pi-exclamation-triangle',
    //  acceptButtonStyleClass: 'p-button-danger p-button-sm',
    //  accept: () => {
    this.sedoristService.delete({ id: sedoristId }, (resp) => {
      if (this.selectedFromMeged) {
        this.mergedList = this.mergedList.filter((p) => p.sedoristId !== sedoristId);
      } else {
        this.sedorists = this.sedorists.filter((p) => p.id !== sedoristId);
      }
      this.messageService.setFlashMessageWithClear('success', '削除成功', '削除しました', 3000);
      this.showSedoristModal = false;
    });
    //  },
    //});
  }

  // チェックした行に同じ仕入店舗を一括設定する
  applyStoreToSelected(op: { hide: () => void }) {
    if (!this.selectedBuyingStore || this.selectedMergeds.length === 0) {
      return;
    }
    const storeId = this.selectedBuyingStore.id;
    const storeName = this.selectedBuyingStore.name;
    this.selectedMergeds.forEach((m) => {
      if (m.sedoristId) {
        this.sedoristService.updateSettings({ id: m.sedoristId, storeId }, () => {});
      }
      if (m.pricetarId) {
        this.pricetarService.updateSettings({ id: m.pricetarId, storeId }, () => {});
      }
      m.buyingStore = storeName;
    });
    const count = this.selectedMergeds.length;
    this.selectedBuyingStore = undefined;
    op.hide();
    this.messageService.setFlashMessageWithClear('success', '完了', count + '件に仕入店舗を設定しました', 3000);
  }

  // チェックした行に同じメモを一括設定する
  applyMemoToSelected() {
    const memo = this.bulkMemo;
    if (!memo || this.selectedMergeds.length === 0) {
      return;
    }
    this.selectedMergeds.forEach((m) => {
      if (m.sedoristId) {
        this.sedoristService.updateSettings({ id: m.sedoristId, memo }, () => {});
      }
      if (m.pricetarId) {
        this.pricetarService.updateSettings({ id: m.pricetarId, memo }, () => {});
      }
      m.memo = memo;
    });
    const count = this.selectedMergeds.length;
    this.bulkMemo = '';
    this.messageService.setFlashMessageWithClear('success', '完了', count + '件にメモを設定しました', 3000);
  }

  clearMergedSelection() {
    this.selectedMergeds = [];
  }

  doDeleteMerged(merged: Merged, event?: Event) {
    //this.confirmationService.confirm({
    //  target: event?.target as EventTarget,
    //  message: '本当に削除しますか？',
    //  icon: 'pi pi-exclamation-triangle',
    //  acceptButtonStyleClass: 'p-button-danger p-button-sm',
    //  accept: () => {
    if (merged.serviceName === 'S') {
      this.sedoristService.delete({ id: merged.sedoristId }, (resp) => {
        this.mergedList = this.mergedList.filter((p) => p.sedoristId !== merged.sedoristId);
        this.messageService.setFlashMessageWithClear('success', '削除成功', '削除しました', 3000);
      });
    } else if (merged.serviceName === 'PS') {
      // 統合行は仕入(せどりすと)・売上(プライスター)の両方を削除
      this.sedoristService.delete({ id: merged.sedoristId }, () => {
        this.pricetarService.delete({ id: merged.pricetarId }, (resp) => {
          this.mergedList = this.mergedList.filter((p) => p.pricetarId !== merged.pricetarId);
          this.messageService.setFlashMessageWithClear(
            'success',
            '削除成功',
            '仕入・売上の両データを削除しました',
            3000,
          );
        });
      });
    } else {
      // pricetar
      this.pricetarService.delete({ id: merged.pricetarId }, (resp) => {
        this.mergedList = this.mergedList.filter((p) => p.pricetarId !== merged.pricetarId);
        this.messageService.setFlashMessageWithClear('success', '削除成功', '削除しました', 3000);
      });
    }
    //  },
    //});
  }

  canSetting(email: string): boolean {
    return this.userService.getEmail() === email || this.userService.isAdmin();
  }

  canEdit(email: string): boolean {
    return this.canSetting(email);
  }

  hasLastStore(): boolean {
    return this.lastBuyingStore != null;
  }

  toEditable(sedorist: Sedorist) {
    sedorist.isEditing = true;
  }

  hasPricetar() {
    return this.pricetars && this.pricetars.length > 0;
  }

  hasSedorist() {
    return this.sedorists && this.sedorists.length > 0;
  }

  hasMerged() {
    return this.mergedList && this.mergedList.length > 0;
  }

  getProfitStyle(profit: number): string {
    if (profit < 0) {
      return 'color: red';
    }
    return 'color: blue';
  }

  updateSedoristStore(op) {
    this._updateSedoristStore(() => {
      op.hide();
    }, true);
  }

  updateSameSedoristStore(buyingStore, sedoristId) {
    this.selectedBuyingStore = buyingStore;
    this.selectedColumnId = sedoristId;
    this._updateSedoristStore(() => {}, true);
  }

  _updateSedoristStore(cb, doExecUpdateSelf: boolean) {
    if (!this.selectedBuyingStore || !this.selectedColumnId) {
      return;
    }
    const body = {
      id: this.selectedColumnId,
      storeId: this.selectedBuyingStore.id,
    };
    this.sedoristService.updateSettings(body, (resp) => {
      if (doExecUpdateSelf) {
        const s = this.sedorists.find((sedo) => sedo.id === this.selectedColumnId);
        s.buyingStore = this.selectedBuyingStore.name;
      }
      this.selectedBuyingStore = undefined;
      this.selectedColumnId = undefined;
      this.selectedMerged = undefined;
      cb();
    });
    this.lastBuyingStore = this.selectedBuyingStore;
  }

  updatePricetarStore(op) {
    this._updatePricetarStore(() => {
      op.hide();
    }, true);
  }

  updateSamePricetarStore(buyingStore, pricetarId) {
    this.selectedBuyingStore = buyingStore;
    this.selectedColumnId = pricetarId;
    this._updatePricetarStore(() => {}, true);
  }

  _updatePricetarStore(cb, doExecUpdateSelf: boolean) {
    if (!this.selectedBuyingStore || !this.selectedColumnId) {
      return;
    }
    const body = {
      id: this.selectedColumnId,
      storeId: this.selectedBuyingStore.id,
    };
    this.pricetarService.updateSettings(body, (resp) => {
      if (doExecUpdateSelf) {
        const s = this.pricetars.find((sedo) => sedo.id === this.selectedColumnId);
        s.buyingStore = this.selectedBuyingStore?.name;
      }
      this.selectedBuyingStore = undefined;
      this.selectedColumnId = undefined;
      this.selectedMerged = undefined;
      cb();
    });
    this.lastBuyingStore = this.selectedBuyingStore;
  }

  updateMergedStore(op) {
    this._updateMergedStore(() => {
      op.hide();
    });
  }

  updateSameMergedStore(buyingStore, merged: Merged) {
    this.selectedBuyingStore = buyingStore;
    this.selectedMerged = merged;
    this._updateMergedStore(() => {});
  }

  _updateMergedStore(cb) {
    if (!this.selectedMerged) {
      return;
    }
    if (this.selectedMerged.serviceName === 'S') {
      this.selectedColumnId = this.selectedMerged.sedoristId;
      this._updateSedoristStore(() => {
        cb();
      }, false);
    } else if (this.selectedMerged.serviceName === 'PS') {
      // 統合行は両方のレコードに仕入店舗を反映
      this.sedoristService.updateSettings(
        { id: this.selectedMerged.sedoristId, storeId: this.selectedBuyingStore.id },
        () => {},
      );
      this.selectedColumnId = this.selectedMerged.pricetarId;
      this._updatePricetarStore(() => {
        cb();
      }, false);
    } else {
      this.selectedColumnId = this.selectedMerged.pricetarId;
      this._updatePricetarStore(() => {
        cb();
      }, false);
    }
    this.selectedMerged.buyingStore = this.selectedBuyingStore.name;
  }

  openIdModal(op, ev, id) {
    op.toggle(ev);
    this.selectedColumnId = id;
  }

  openStoreMerged(op, ev, merged: Merged) {
    op.toggle(ev);
    this.selectedMerged = merged;
  }

  openPricetarModal(pricetar: Pricetar) {
    this.selectedColumnId = pricetar.id;
    this.settingPublic = pricetar.isPublic;
    this.settingIsPriceDownInCacheRegister = pricetar.isPriceDownInCacheRegister;
    this.settingIsSleeped = pricetar.isSleeped;
    this.settingMemo = pricetar.memo;
    this.settingIpMemo = pricetar.ipMemo;
    this.selectedFromMeged = false;

    this.showPricetarModal = true;
  }

  openSedoristModal(sedorist: Sedorist) {
    this.selectedColumnId = sedorist.id;
    this.settingPublic = sedorist.isPublic;
    this.settingIsPriceDownInCacheRegister = sedorist.isPriceDownInCacheRegister;
    this.settingIsSleeped = sedorist.isSleeped;
    this.settingMemo = sedorist.memo;
    this.settingIpMemo = sedorist.ipMemo;
    this.selectedFromMeged = false;

    this.showSedoristModal = true;
  }

  openMergedModal(merged: Merged) {
    this.settingPublic = merged.isPublic;
    this.settingIsPriceDownInCacheRegister = merged.isPriceDownInCacheRegister;
    this.settingIsSleeped = merged.isSleeped;
    this.settingMemo = merged.memo;
    this.settingIpMemo = merged.ipMemo;
    this.selectedFromMeged = true;

    if (merged.serviceName === 'S') {
      this.selectedColumnId = merged.sedoristId;
      this.showSedoristModal = true;
    } else {
      this.selectedColumnId = merged.pricetarId;
      this.showPricetarModal = true;
    }
  }

  setSettingIsPublic(ev) {
    this.settingPublic = ev.checked;
  }

  setSettingIsSleeped(ev) {
    this.settingIsSleeped = ev.checked;
  }

  setSettingIsPriceDownInCacheRegister(ev) {
    this.settingIsPriceDownInCacheRegister = ev.checked;
  }

  setSettingIsPriceNegotiation(ev) {
    console.log('hog');
    this.settingIsPriceNegotiation = ev.checked;
  }

  updatePricetarSetting() {
    this._updatePricetar(
      this.settingMemo,
      this.settingIpMemo,
      this.settingIsPriceDownInCacheRegister,
      this.settingIsPriceNegotiation,
      this.settingIsSleeped,
      this.settingPublic,
      () => {
        this.showPricetarModal = false;
      },
    );
  }

  updateSedoristSetting() {
    this._updateSedorist(
      this.settingMemo,
      this.settingIpMemo,
      this.settingIsPriceDownInCacheRegister,
      this.settingIsPriceNegotiation,
      this.settingIsSleeped,
      this.settingPublic,
      () => {
        this.showSedoristModal = false;
      },
    );
  }

  async doSearchSedorist() {
    this.clear();
    this.sedorists = this.collapseBySku(await this.searchSedorist());
  }

  _updatePricetar(
    memo?: string,
    ipMemo?: string,
    isPriceDownInCacheRegister?: boolean,
    isPriceNegotiation?: boolean,
    isSleeped?: boolean,
    isPublic?: boolean,
    cb?: any,
  ) {
    const body: UpdateUserPricetarProductMutationVariables = {
      id: this.selectedColumnId,
      memo,
      ipMemo,
      isPriceDownInCacheRegister,
      isPriceNegotiation,
      isSleeped,
      isPublic,
    };
    this.pricetarService.updateSettings(body, (resp) => {
      var s: Pricetar | Merged;
      if (this.selectedFromMeged) {
        s = this.mergedList.find((sedo) => sedo.pricetarId === this.selectedColumnId);
      } else {
        s = this.pricetars.find((sedo) => sedo.id === this.selectedColumnId);
      }
      s.memo = memo;
      s.ipMemo = ipMemo;
      s.isPriceDownInCacheRegister = isPriceDownInCacheRegister;
      s.isSleeped = isSleeped;
      s.isPublic = isPublic;
      s.isPriceNegotiation = isPriceNegotiation;

      // 統合行はせどりすと側のレコードにも同じ設定を反映
      const m = s as Merged;
      if (m.serviceName === 'PS' && m.sedoristId) {
        this.sedoristService.updateSettings(
          { id: m.sedoristId, memo, ipMemo, isPriceDownInCacheRegister, isPriceNegotiation, isSleeped, isPublic },
          () => {},
        );
      }

      this.selectedColumnId = undefined;
      this.selectedFromMeged = false;
      this.selectedMerged = undefined;
      if (cb) {
        cb();
      }
    });
  }

  _updateSedorist(
    memo?: string,
    ipMemo?: string,
    isPriceDownInCacheRegister?: boolean,
    isPriceNegotiation?: boolean,
    isSleeped?: boolean,
    isPublic?: boolean,
    cb?: any,
  ) {
    const body: UpdateUserSedoristProductMutationVariables = {
      id: this.selectedColumnId,
      memo,
      ipMemo,
      isPriceDownInCacheRegister,
      isPriceNegotiation,
      isSleeped,
      isPublic,
    };
    this.sedoristService.updateSettings(body, (resp) => {
      var s: Sedorist | Merged;
      if (this.selectedFromMeged) {
        s = this.mergedList.find((sedo) => sedo.sedoristId === this.selectedColumnId);
      } else {
        s = this.sedorists.find((sedo) => sedo.id === this.selectedColumnId);
      }

      s.memo = memo;
      s.ipMemo = ipMemo;
      s.isPriceDownInCacheRegister = isPriceDownInCacheRegister;
      s.isSleeped = isSleeped;
      s.isPublic = isPublic;
      s.isPriceNegotiation = isPriceNegotiation;

      this.selectedColumnId = undefined;
      this.selectedFromMeged = false;
      this.selectedMerged = undefined;
      if (cb) {
        cb();
      }
    });
  }

  updateMerged(
    merged: Merged,
    memo?: string,
    ipMemo?: string,
    isPriceDownInCacheRegister?: boolean,
    isPriceNegotiation?: boolean,
    isSleeped?: boolean,
    isPublic?: boolean,
  ) {
    merged.isPublic = isPublic;
    merged.memo = memo;
    merged.isPriceDownInCacheRegister = isPriceDownInCacheRegister;
    merged.isSleeped = isSleeped;
    merged.isPriceNegotiation = isPriceNegotiation;

    if (merged.serviceName === 'S') {
      this._updateSedorist(memo, ipMemo, isPriceDownInCacheRegister, isPriceNegotiation, isSleeped, isPublic);
    } else {
      // pricetar
      this._updatePricetar(memo, ipMemo, isPriceDownInCacheRegister, isPriceNegotiation, isSleeped, isPublic);
    }
  }

  getRowStyle(isPublic: boolean) {
    if (!isPublic) {
      return 'unpublic';
    }
    return '';
  }

  private async searchSedorist(): Promise<Sedorist[]> {
    const v = this.form.value;
    const buyingStoreIds = v.buyingStore ? [v.buyingStore.id] : undefined;
    const buyingStoreTypeId = v.buyingStoreType ? v.buyingStoreType.id : undefined;
    const keyword = v.keyword;
    const filterUserProduct = v.sharedOption.value;
    const fromDate = moment(v.fromDate).format('YYYY-MM-DD');
    const toDate = moment(v.toDate).format('YYYY-MM-DD');
    const filterUserIds = v.user?.map((u) => u.id);
    const filterOtherSetting = v.otherSetting?.value;
    const amazonCategoryId = v.amazonCategory?.id;
    const body: UserSedoristProductsQueryVariables = {
      keyword,
      fromDate,
      toDate,
      filterUserProduct,
      filterOtherSetting,
      buyingStoreIds,
      buyingStoreTypeId,
      filterUserIds,
      amazonCategoryId,
    };
    const result = [];

    await this.sedoristService.list(body, (data) => {
      data.userSedoristProducts.forEach((p) => {
        if (this.shouldHideProduct(p.sheetData)) {
          return;
        }
        let jan = '';
        if (p.product) {
          jan = p.product.jan;
        }
        const buyingStore = p.buyingStore && p.buyingStore.name;
        let commission = 0;
        if (p.amazonProduct.salesCommission) {
          commission += p.amazonProduct.salesCommission;
        }
        if (p.amazonProduct.categoryFee) {
          commission += p.amazonProduct.categoryFee;
        }
        if (p.amazonProduct.fbaShippingFee) {
          commission += p.amazonProduct.fbaShippingFee;
        }
        const profit = p.sellingPrice - p.buyingPrice - commission;
        const profitRate = profit / p.sellingPrice;
        result.push({
          id: p.id,
          asin: p.amazonProduct.asin,
          imageUrl: p.amazonProduct.imageUrl,
          jan,
          sku: p.sku,
          email: p.user.email,
          name: p.user.name,
          productName: p.productName,
          buyingPrice: p.buyingPrice,
          sellingPrice: p.sellingPrice,
          profit,
          profitRate,
          buyingDate: new Date(p.buyingDate),
          buyingStore,
          isEditing: false,
          condition: p.condition,
          topCategory: p.topCategory,
          deliveryRoute: p.deliveryRoute,
          memo: p.memo,
          ipMemo: p.ipMemo,
          isPriceDownInCacheRegister: p.isPriceDownInCacheRegister,
          isSleeped: p.isSleeped,
          isPriceNegotiation: p.isPriceNegotiation,
          isPublic: p.isPublic,
          createdAt: new Date(p.createdAt),
          sheetData: p.sheetData,
          images: p.images ?? [],
        });
      });
    });
    return result;
  }

  // らくじゃん上の表示は「実際に仕入れて売れた商品」を1回見せれば十分なので、
  // 同一ユーザー・同一SKUの行は利益率が最も高い1行に集約する（DBは変更しない・表示のみ）。
  // 売上台帳としての複数販売行は別物なので、ここでの集約は表示上の話。
  private collapseBySku<
    T extends {
      email: string;
      sku: string;
      profitRate: number;
      images?: ProductImageFieldsFragment[];
      buyingStore?: string;
      memo?: string;
      ipMemo?: string;
    },
  >(rows: T[]): T[] {
    const byKey = new Map<string, T>();
    const result: T[] = [];
    rows.forEach((row, i) => {
      // SKUが無い行は集約せずそのまま残す
      const key = row.sku ? row.email + '\t' + row.sku : '__nosku__' + i;
      const existing = byKey.get(key);
      if (!existing) {
        byKey.set(key, row);
        result.push(row);
        return;
      }
      // 利益率が高い方を代表に採用（同率なら既存を維持）
      const winner = row.profitRate > existing.profitRate ? row : existing;
      const loser = winner === row ? existing : row;
      // 画像は両方の和集合を保持
      const imageIds = new Set((winner.images ?? []).map((img) => img.id));
      winner.images = [...(winner.images ?? []), ...(loser.images ?? []).filter((img) => !imageIds.has(img.id))];
      // 手動入力(仕入店舗・メモ)は空なら相手から補完
      if (!winner.buyingStore) {
        winner.buyingStore = loser.buyingStore;
      }
      if (!winner.memo) {
        winner.memo = loser.memo;
      }
      if (!winner.ipMemo) {
        winner.ipMemo = loser.ipMemo;
      }
      if (winner !== existing) {
        const idx = result.indexOf(existing);
        if (idx >= 0) {
          result[idx] = winner;
        }
        byKey.set(key, winner);
      }
    });
    return result;
  }

  async doSearchMerged() {
    this.clear();
    const pricetars = this.collapseBySku(await this.searchPricetar());
    const sedorists = this.collapseBySku(await this.searchSedorist());

    this.mergedList = [];
    pricetars.forEach((p) => {
      this.mergedList.push({
        sedoristId: undefined,
        pricetarId: p.id,
        asin: p.asin,
        imageUrl: p.imageUrl,
        jan: p.jan,
        sku: p.sku,
        email: p.email,
        name: p.name,
        productName: p.productName,
        buyingPrice: p.buyingPrice,
        sellingPrice: p.sellingPrice,
        profit: p.profit,
        profitRate: p.profitRate,
        buyingDate: p.orderDate,
        buyingStore: p.buyingStore,
        condition: p.condition,
        deliveryRoute: p.deliveryRoute,
        memo: p.memo,
        ipMemo: p.ipMemo,
        isPriceDownInCacheRegister: p.isPriceDownInCacheRegister,
        isSleeped: p.isSleeped,
        topCategory: p.topCategory,
        isPublic: p.isPublic,
        isPriceNegotiation: p.isPriceNegotiation,
        serviceName: 'P',
        createdAt: p.createdAt,
        sheetData: p.sheetData,
        images: p.images ?? [],
      });
    });

    // 同一ユーザー・同一SKUのプライスター行を引き当てるための索引
    const pricetarBySku = new Map<string, Merged>();
    this.mergedList.forEach((m) => {
      const key = m.email + '\t' + m.sku;
      if (!pricetarBySku.has(key)) {
        pricetarBySku.set(key, m);
      }
    });

    sedorists.forEach((p) => {
      // 仕入(せどりすと)と売上(プライスター)が揃った商品は1行に統合する
      const paired = p.sku ? pricetarBySku.get(p.email + '\t' + p.sku) : undefined;
      if (paired && !paired.sedoristId) {
        paired.sedoristId = p.id;
        paired.serviceName = 'PS';
        if (!paired.buyingStore) {
          paired.buyingStore = p.buyingStore;
        }
        if (!paired.memo) {
          paired.memo = p.memo;
        }
        if (!paired.ipMemo) {
          paired.ipMemo = p.ipMemo;
        }
        const imageIds = new Set((paired.images ?? []).map((img) => img.id));
        paired.images = [...(paired.images ?? []), ...(p.images ?? []).filter((img) => !imageIds.has(img.id))];
        return;
      }
      this.mergedList.push({
        sedoristId: p.id,
        pricetarId: undefined,
        asin: p.asin,
        imageUrl: p.imageUrl,
        jan: p.jan,
        sku: p.sku,
        email: p.email,
        name: p.name,
        productName: p.productName,
        buyingPrice: p.buyingPrice,
        sellingPrice: p.sellingPrice,
        profit: p.profit,
        profitRate: p.profitRate,
        buyingDate: p.buyingDate,
        buyingStore: p.buyingStore,
        condition: p.condition,
        deliveryRoute: p.deliveryRoute,
        memo: p.memo,
        ipMemo: p.ipMemo,
        isPriceDownInCacheRegister: p.isPriceDownInCacheRegister,
        isSleeped: p.isSleeped,
        topCategory: p.topCategory,
        isPublic: p.isPublic,
        isPriceNegotiation: p.isPriceNegotiation,
        serviceName: 'S',
        createdAt: p.createdAt,
        sheetData: p.sheetData,
        images: p.images ?? [],
      });
    });
  }

  outputPricetarCsv() {
    const csv =
      'ASIN,JAN,仕入値,在庫数,販売価格,購入店舗\n' +
      this.pricetars
        .map((p) => {
          return [p.asin, p.jan, p.buyingPrice, 1, p.sellingPrice, p.buyingStore].join(',');
        })
        .join('\n');

    this.outputCsv(csv, 'pricetar.csv');
  }

  outputAllPricetarCsv() {
    const csv =
      '画像URL,ASIN,JAN,商品名,仕入値,売価,利益額,利益率,状態,SKU,注文日,配送経路,仕入店舗,登録者\n' +
      this.pricetars
        .map((p) => {
          return [
            p.imageUrl,
            p.asin,
            p.jan,
            p.productName,
            p.buyingPrice,
            p.sellingPrice,
            p.profit,
            p.profitRate,
            p.condition,
            p.sku,
            moment(p.orderDate).format('YYYY/MM/DD'),
            p.deliveryRoute,
            p.buyingStore,
            p.name,
          ].join(',');
        })
        .join('\n');

    this.outputCsv(csv, 'pricetar.csv');
  }

  outputSedoristCsv() {
    const csv =
      'ASIN,JAN,仕入値,在庫数,販売価格,購入店舗\n' +
      this.sedorists
        .map((p) => {
          return [p.asin, p.jan, p.buyingPrice, 1, p.sellingPrice, p.buyingStore].join(',');
        })
        .join('\n');

    this.outputCsv(csv, 'sedorist.csv');
  }

  outputAllSedoristCsv() {
    const csv =
      '画像URL,asin,JAN,商品名,仕入値,出品予定価格,利益額,利益率,状態,SKU,配送経路,仕入日,仕入店舗,登録者\n' +
      this.sedorists
        .map((p) => {
          return [
            p.imageUrl,
            p.asin,
            p.jan,
            p.productName,
            p.buyingPrice,
            p.sellingPrice,
            p.profit,
            p.profitRate,
            p.condition,
            p.sku,
            p.deliveryRoute,
            moment(p.buyingDate).format('YYYY/MM/DD'),
            p.buyingStore,
            p.name,
          ].join(',');
        })
        .join('\n');

    this.outputCsv(csv, 'sedorist.csv');
  }

  outputMergedCsv() {
    const csv =
      'jan,仕入値,在庫数,販売価格,購入店舗\n' +
      this.mergedList
        .map((p) => {
          return [p.jan, p.buyingPrice, 1, p.sellingPrice, p.buyingStore].join(',');
        })
        .join('\n');

    this.outputCsv(csv, 'pricetar_and_sedorist.csv');
  }

  outputAllMergedCsv() {
    const csv =
      '画像URL,asin,jan,商品名,仕入値,出品予定価格,利益額,利益率,SKU,配送経路,仕入日,仕入店舗,登録者\n' +
      this.mergedList
        .map((p) => {
          return [
            p.imageUrl,
            p.asin,
            p.jan,
            p.productName,
            p.buyingPrice,
            p.sellingPrice,
            p.profit,
            p.profitRate,
            p.sku,
            p.deliveryRoute,
            moment(p.buyingDate).format('YYYY/MM/DD'),
            p.buyingStore,
            p.name,
          ].join(',');
        })
        .join('\n');

    this.outputCsv(csv, 'pricetar_and_sedorist.csv');
  }

  private outputCsv(csv: string, filename: string) {
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const blob = new Blob([bom, csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const elem = this.elementRef.nativeElement;
    const link = elem.querySelector('#csv-donwload') as HTMLAnchorElement;
    link.href = url;
    link.download = filename;
    link.click();
  }

  // sheetDataのバッジを取得するためのヘルパーメソッド
  getSheetDataBadges(sheetData?: {
    Yamada?: string | null;
    Edion?: string | null;
    Donki?: string | null;
  }): Array<{ label: string; id: string; severity: string }> {
    const badges = [];

    if (!sheetData) {
      return badges;
    }

    if (sheetData.Yamada && sheetData.Yamada !== null) {
      badges.push({ label: 'ヤマダ', id: sheetData.Yamada, severity: 'warning' });
    }

    if (sheetData.Edion && sheetData.Edion !== null) {
      badges.push({ label: 'エディオン', id: sheetData.Edion, severity: 'info' });
    }

    if (this.canShowDonki() && sheetData.Donki && sheetData.Donki !== null) {
      badges.push({ label: 'ドンキ', id: sheetData.Donki, severity: 'contrast' });
    }

    return badges;
  }

  // sheetDataがある場合の行スタイルを取得するヘルパーメソッド
  getRowStyleWithSheetData(
    isPublic: boolean,
    sheetData?: { Yamada?: string | null; Edion?: string | null; Donki?: string | null },
  ): string {
    const baseStyle = this.getRowStyle(isPublic);

    if (sheetData && this.hasSheetData(sheetData)) {
      return baseStyle ? `${baseStyle} sheet-data-row` : 'sheet-data-row';
    }

    return baseStyle;
  }

  // sheetDataが存在するかチェックするヘルパーメソッド
  hasSheetData(sheetData?: { Yamada?: string | null; Edion?: string | null; Donki?: string | null }): boolean {
    if (!sheetData) {
      return false;
    }
    return !!(sheetData.Yamada || sheetData.Edion || sheetData.Donki);
  }

  trackByBadge(index: number, badge: any): any {
    return badge.id || index;
  }

  handleBadgeClick(badge: any, event: Event): void {
    // イベントの伝播を停止
    event.preventDefault();
    event.stopPropagation();

    // 変更検知を強制実行
    this.cdr.detectChanges();

    const productType = badge.label === 'ヤマダ' ? 'yamada' : badge.label === 'エディオン' ? 'edion' : 'donki';

    this.onBadgeClick(productType, badge.id, event);
  }

  // バッジクリック時に商品詳細ダイアログを開く
  async onBadgeClick(type: 'yamada' | 'edion' | 'donki', id: string, event?: Event) {
    console.log('Badge clicked:', type, id);

    // イベントのバブリングを停止
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!id || !type) {
      console.error('Invalid parameters:', { type, id });
      this.messageService.setFlashMessageWithClear('error', 'エラー', '無効なパラメータです');
      return;
    }

    // 既にダイアログが開いている場合は閉じる
    if (this.showProductDetailDialog) {
      this.closeProductDetailDialog();
    }

    // 少し待ってからダイアログを開く（状態をクリアするため）
    setTimeout(async () => {
      this.selectedProductType = type;
      this.selectedProductId = id;
      this.showProductDetailDialog = true;
      this.isLoadingProductDetail = true;
      this.productDetailData = null;

      try {
        await this.loadProductDetail(type, id);
      } catch (error) {
        console.error('Error loading product detail:', error);
        this.messageService.setFlashMessageWithClear('error', 'エラー', '商品詳細の取得に失敗しました');
        this.showProductDetailDialog = false;
      } finally {
        this.isLoadingProductDetail = false;
      }
    }, 100);
  }

  // 商品詳細データを取得
  private async loadProductDetail(type: 'yamada' | 'edion' | 'donki', id: string) {
    console.log('Loading product detail:', type, id);

    if (!id) {
      throw new Error('Product ID is required');
    }

    // 分岐ごとに別々の GQL レスポンス型が入るため any のまま扱う
    let response: any;

    try {
      switch (type) {
        case 'yamada':
          console.log('Fetching yamada product...');
          response = await firstValueFrom(
            this.yamadaProductsGQL.fetch({
              variables: {
                id,
                // registrationDateを明示的にnullに設定
                registrationDate: null,
              },
            }),
          );
          this.productDetailData = response.data.yamadaProducts?.[0] || null;
          break;
        case 'edion':
          console.log('Fetching edion product...');
          response = await firstValueFrom(
            this.edionProductsGQL.fetch({
              variables: {
                id,
                registrationDate: null,
              },
            }),
          );
          this.productDetailData = response.data.edionProducts?.[0] || null;
          break;
        case 'donki':
          console.log('Fetching donki product...');
          response = await firstValueFrom(
            this.donkiProductsGQL.fetch({
              variables: {
                id,
                registrationDate: null,
              },
            }),
          );
          this.productDetailData = response.data.donkiProducts?.[0] || null;
          break;
        default:
          throw new Error(`Unknown product type: ${type}`);
      }

      console.log('Product data loaded:', this.productDetailData);

      if (!this.productDetailData) {
        throw new Error(`No product found for ${type} with ID: ${id}`);
      }

      // エリア情報を抽出してセットアップ
      this.setupAreaFilter();
    } catch (error) {
      console.error('GraphQL fetch error:', error);
      throw error;
    }
  }

  // エリアフィルターのセットアップ
  private setupAreaFilter() {
    if (!this.productDetailData?.stocks) {
      this.availableAreas = [];
      this.selectedArea = null;
      this.filteredStocks = [];
      return;
    }

    // 重複なしのエリア一覧を作成
    const areaMap = new Map<string, { id: string; name: string; value: string }>();
    this.productDetailData.stocks.forEach((stock: any) => {
      if (stock.store?.area?.id && stock.store?.area?.name) {
        areaMap.set(stock.store.area.id, {
          id: stock.store.area.id,
          name: stock.store.area.name,
          value: stock.store.area.id,
        });
      }
    });

    this.availableAreas = Array.from(areaMap.values()).sort((a, b) => a.name.localeCompare(b.name));

    // 「全て」オプションを先頭に追加
    this.availableAreas.unshift({
      id: 'all',
      name: '全てのエリア',
      value: 'all',
    });

    // 初期状態では「全て」を選択
    this.selectedArea = 'all';

    // フィルター適用
    this.applyAreaFilter();
  }

  // エリアフィルターの適用
  applyAreaFilter() {
    if (!this.productDetailData?.stocks) {
      this.filteredStocks = [];
      return;
    }

    // 「全て」が選択されている場合、または何も選択されていない場合は全て表示
    if (!this.selectedArea || this.selectedArea === 'all') {
      this.filteredStocks = [...this.productDetailData.stocks];
      return;
    }

    // 特定のエリアが選択されている場合はフィルタリング
    this.filteredStocks = this.productDetailData.stocks.filter((stock: any) => {
      return stock.store?.area?.id === this.selectedArea;
    });
  }

  // エリア選択の変更時
  onAreaSelectionChange() {
    this.applyAreaFilter();
  }

  // ダイアログを閉じる
  closeProductDetailDialog() {
    this.showProductDetailDialog = false;
    this.selectedProductType = null;
    this.selectedProductId = null;
    this.productDetailData = null;
    this.availableAreas = [];
    this.selectedArea = null;
    this.filteredStocks = [];
  }

  canShowDonki(): boolean {
    return this.userService.hasFuncDonki();
  }

  // 画像ギャラリーを開く (pricetar)
  openPricetarImages(pricetar: Pricetar): void {
    this.imageGallerySource = 'pricetar';
    this.imageGalleryOwnerType = 'pricetar';
    this.imageGalleryOwnerId = pricetar.id;
    this.imageGalleryImages = pricetar.images ?? [];
    this.imageGalleryCanEdit = this.canEdit(pricetar.email);
    this.imageGalleryProductName = pricetar.productName;
    this.showImageGalleryDialog = true;
  }

  sortedImages(images?: ProductImageFieldsFragment[]): ProductImageFieldsFragment[] {
    return [...(images ?? [])].sort((a, b) => a.position - b.position);
  }

  // 画像ギャラリーを開く (sedorist)
  openSedoristImages(sedorist: Sedorist): void {
    this.imageGallerySource = 'sedorist';
    this.imageGalleryOwnerType = 'sedorist';
    this.imageGalleryOwnerId = sedorist.id;
    this.imageGalleryImages = sedorist.images ?? [];
    this.imageGalleryCanEdit = this.canEdit(sedorist.email);
    this.imageGalleryProductName = sedorist.productName;
    this.showImageGalleryDialog = true;
  }

  // 画像ギャラリーを開く (merged)
  openMergedImages(merged: Merged): void {
    this.imageGallerySource = 'merged';
    if (merged.serviceName === 'S') {
      this.imageGalleryOwnerType = 'sedorist';
      this.imageGalleryOwnerId = merged.sedoristId;
    } else {
      this.imageGalleryOwnerType = 'pricetar';
      this.imageGalleryOwnerId = merged.pricetarId;
    }
    this.imageGalleryImages = merged.images ?? [];
    this.imageGalleryCanEdit = this.canEdit(merged.email);
    this.imageGalleryProductName = merged.productName;
    this.showImageGalleryDialog = true;
  }

  // 画像変更 (アップロード/削除) 後にリストを再取得
  async onImagesChanged(): Promise<void> {
    const source = this.imageGallerySource;
    const ownerType = this.imageGalleryOwnerType;
    const ownerId = this.imageGalleryOwnerId;
    if (!ownerType || !ownerId) {
      return;
    }
    if (source === 'pricetar') {
      this.pricetars = await this.searchPricetar();
      const refreshed = this.pricetars.find((p) => p.id === ownerId);
      this.imageGalleryImages = refreshed?.images ?? [];
    } else if (source === 'sedorist') {
      this.sedorists = await this.searchSedorist();
      const refreshed = this.sedorists.find((p) => p.id === ownerId);
      this.imageGalleryImages = refreshed?.images ?? [];
    } else if (source === 'merged') {
      await this.doSearchMerged();
      const refreshed = this.mergedList.find((m) =>
        ownerType === 'sedorist' ? m.sedoristId === ownerId : m.pricetarId === ownerId,
      );
      this.imageGalleryImages = refreshed?.images ?? [];
    }
  }

  closeImageGalleryDialog(): void {
    this.showImageGalleryDialog = false;
    this.imageGalleryOwnerType = null;
    this.imageGalleryOwnerId = null;
    this.imageGalleryImages = [];
    this.imageGalleryCanEdit = false;
    this.imageGalleryProductName = '';
    this.imageGallerySource = null;
  }
}

interface ProductShareFilterParam {
  keyword: string;
  fromDate: Date;
  toDate: Date;
  sharedOnly: boolean;
  nonSharedOnly: boolean;
}

interface Pricetar {
  id: number;
  asin: string;
  jan: string;
  imageUrl: string;
  sku: string;
  email: string;
  name: string;
  productName: string;
  buyingPrice: number;
  sellingPrice: number;
  orderDate: Date;
  deliveryRoute: string;
  memo: string;
  ipMemo: string;
  isPriceDownInCacheRegister: boolean;
  isSleeped: boolean;
  buyingStore: string;
  salesCommission: number;
  profit: number;
  profitRate: number;
  condition: string;
  topCategory: string;
  isPublic: boolean;
  isPriceNegotiation: boolean;
  createdAt: Date;
  sheetData?: {
    Yamada?: string | null;
    Edion?: string | null;
    Donki?: string | null;
  };
  images?: ProductImageFieldsFragment[];
}

interface Sedorist {
  id: number;
  asin: string;
  imageUrl: string;
  jan: string;
  sku: string;
  email: string;
  name: string;
  productName: string;
  buyingPrice: number;
  sellingPrice: number;
  profit: number;
  profitRate: number;
  buyingDate: Date;
  buyingStore: string;
  deliveryRoute: string;
  memo: string;
  ipMemo: string;
  isPriceDownInCacheRegister: boolean;
  isSleeped: boolean;
  isEditing: boolean;
  condition: string;
  topCategory: string;
  isPublic: boolean;
  isPriceNegotiation: boolean;
  createdAt: Date;
  sheetData?: {
    Yamada?: string | null;
    Edion?: string | null;
    Donki?: string | null;
  };
  images?: ProductImageFieldsFragment[];
}

// sedorist / pricetarをマージしたobject
interface Merged {
  sedoristId: number;
  pricetarId: number;
  asin: string;
  imageUrl: string;
  jan: string;
  sku: string;
  email: string;
  name: string;
  productName: string;
  buyingPrice: number;
  sellingPrice: number;
  profit: number;
  profitRate: number;
  buyingDate: Date;
  buyingStore: string;
  condition: string;
  deliveryRoute: string;
  memo: string;
  ipMemo: string;
  isPriceDownInCacheRegister: boolean;
  isSleeped: boolean;
  topCategory: string;
  isPublic: boolean;
  isPriceNegotiation: boolean;
  serviceName: string; // sedorist or pricetar
  createdAt: Date;
  sheetData?: {
    Yamada?: string | null;
    Edion?: string | null;
    Donki?: string | null;
  };
  images?: ProductImageFieldsFragment[];
}

interface BuyingStore {
  id: number;
  name: string;
}

interface BuyingStoreType {
  id: number;
  name: string;
  stores: Array<BuyingStore>;
}

interface AmazonCategory {
  id: number;
  name: string;
}
